export const TAXES_REQUEST = 'TaxesRequest';
export const TAXES_FAILURE = 'TaxesFailure';
export const TAXES_SUCCESS = 'TaxesSuccess';